import { useQuery } from '@tanstack/react-query';

import flexControlAccountClient from '@clients/domains/flexControls/flexControlAccountClient';
import notifyAPIError from '@utils/notifyAPIError';

const { getFlexCardControlAccount } = flexControlAccountClient();

type useGetCardControlsProps = {
    accountId: string;
    flexId: string;
};

const useGetFlexControlAccount = ({
    accountId,
    flexId,
}: useGetCardControlsProps) => {
    const { data, error, isError, isLoading } = useQuery(
        ['getFlexControlAccount', accountId, flexId],
        () =>
            getFlexCardControlAccount({
                accountId: accountId,
                flexId: flexId,
            }),
        {
            onError: notifyAPIError,
        },
    );

    return { data, error, isError, isLoading };
};

export default useGetFlexControlAccount;
